import React from 'react';

class Work extends React.Component {
    render(){
        return(<div>
            this is work
        </div>)
    }
}

export {Work};